module.exports = __webpack_public_path__ + "static/media/customizacion.ec2ccd90.png";